import { createContext } from 'react'

import { NavigationStackContextType } from './NavigationStackContext.types'

export const NavigationStackContext =
  createContext<NavigationStackContextType>(undefined)
